export default __webpack_public_path__ + "static/media/vod-as-live-icon.20b5005d.png";